import { ACTIONS } from "features/planner/planner.constants";
import { SearchResultMapper } from "features/planner/planner.mappers";

const initialState = SearchResultMapper.initial();

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.SEARCH_VIEW: {
      if (error) return state;

      const { searchResult } = payload;

      return SearchResultMapper.from(searchResult);
    }

    case ACTIONS.CLEAR_SEARCH: {
      return initialState;
    }

    default:
      return state;
  }
};
